'use client';

import { useAtomValue } from 'jotai/index';

import { isMapViewAtom } from '@/features/listing/atoms/is-map-view-atom';
import { PaginationNames } from '@/features/listing/types/listing-filters-types';
import { type ListingsCollection } from '@/features/listing/types/listing-types';
import Pagination from '@/ui/pagination/pagination';

interface ListingsPaginationProps {
  listingsCount: ListingsCollection['count'];
  listingsPerPage: number;
}

export default function ListingsPagination(props: ListingsPaginationProps) {
  const {
    listingsCount,
    listingsPerPage,
  } = props;

  const isMapView = useAtomValue(isMapViewAtom);

  return isMapView ? null : (
    <Pagination
      itemsCount={listingsCount}
      itemsPerPage={listingsPerPage}
      pageNumberParamName={PaginationNames.PageNumber}
    />
  );
}
